<template lang="pug">
  div
    page_header(title="Testimonial", subhead="Overview")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "testimonial.create", params:{id:id}}')
        i.feather-plus
        | Create New

    .row
      .col-sm-12
        card_table(
          ref="table"
          :url="$backend+'/admin/testimonial'"
          :fields="columns"
          :token="user.token"
          :actions="actions"
          :class="sending?'loading':''"
          @edit="edit"
          @delete="delete_item"
        )
        

</template>

<script>
import page_header from '@/components/pageHeader'
import loading_button from '@/components/loadingBtn'
import card_table from '@/components/tables/card-table'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'Products',
  components: {
    page_header,
    loading_button,
    card_table
  },
  data(){
    return {
      actions: [
        {
          name: 'edit',
          type: 'icon',
          class: 'feather-edit'
        },
        {
          name: 'delete',
          type: 'icon',
          class: 'feather-trash'
        }
      ],
      columns :[
        {
          name: 'name',
          sortField: 'name',
          title: "Name"
        },
        {
          name: 'position',
          title: 'Designation'
        },
        {
          name: 'company',
          title: 'Organisation'
        },
        {
          name: 'status',
          sortField: 'status',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center',
        }

      ],
    }
  },
  computed:{
    ...mapState('auth', ['user']),
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    edit(data){
      this.$router.push({name: 'testimonial.edit', params: {id: data.id}})
    },
    delete_item(data){
      var vm = this;
      if(confirm('Are you sure?')){
        this.call({_vm: this, endpoint:'admin/testimonial/'+data.id, method: 'DELETE'}).then(()=>{
          vm.$refs.table.refreshTable();
        })
      }
    },
    ...mapActions('api', ['call'])
  }

}
</script>